export var ScreenOrientation;
(function (ScreenOrientation) {
    ScreenOrientation["LEFT"] = "left";
    ScreenOrientation["RIGHT"] = "right";
    ScreenOrientation["INVERTED"] = "inverted";
    ScreenOrientation["NORMAL"] = "normal";
})(ScreenOrientation || (ScreenOrientation = {}));
//# sourceMappingURL=ScreenOrientation.js.map